<app-tourism-calendar-event-view
	[selectedObject]="selectedObject"
	[vehicles]="vehicles"
	[drivers]="allDrivers"
	[touristGuides]="touristGuides"
	[users]="users"
	[parameters]="parameters"
	(eventClosed)="eventClosed($event)"
></app-tourism-calendar-event-view>

<app-drivers-calendar-filters
	userFilters="driversCalendar"
	[allDrivers]="allDrivers"
	[statuses]="statuses"
	[driverKinds]="driverKinds"
	[yesno]="parameters.yesno"
	(selected)="filtersSelected($event)"
></app-drivers-calendar-filters>

<app-events-timeline
	[module]="'driversCalendar'"
	[date_from]="date_from"
	[date_to]="date_to"
	[data]="data"
	addLink="/driver-event/add"
	(filtersClicked)="filtersOpen()"
	(eventClicked)="eventOpen($event)"
></app-events-timeline>
